/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {$, InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import ChecklistEntrega from '@/model/resource/ChecklistEntrega'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: ChecklistEntrega): Schema => ({

    codigoServico: {
        content: model.codigoServico,
        input: InputType.TEXT,
        meta: {
            required: false,
            selectall: true,
        },
    },

     descricao: {
        content: model.descricao,
        input: InputType.TEXTAREA,
        meta: {
            required: true,
            selectall: true,
        },

    },

    idTipoChecklistEntregaPkAlt: {
        content: [
            model.tipoChecklistEntrega && model.tipoChecklistEntrega.descricao,
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('idTipoChecklistEntregaPkAlt'),
                    value: (model.tipoChecklistEntrega && model.tipoChecklistEntrega.descricao) || '',
                },
            },
        ],
        textContent: model.tipoChecklistEntrega && model.tipoChecklistEntrega.$tag || '',
        input: InputType.SELECT,
        meta: {
            required: true,
            selectall: true,
        },
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },

    idTipoChecklistEntregaPk: {
        content: model.msgEdicao || model.tipoChecklistEntrega && model.tipoChecklistEntrega.descricao,

    },

    ehEditavel: {
        content: bool(model.ehEditavel),
        input: InputType.CHECKBOX,
    },
})
